import React, { useState } from 'react';
import BreadcrumbComp from '@components/UI/Breadcrumb/Index.jsx';
import FilterAdmin from "@components/Solicitacao/Admin/Consultar/Filter.jsx";
import { useGenericReducer } from '@hooks/state/useGenericReducer.js';
import GridConsultasSolicitacoes from '@components/Solicitacao/Admin/Consultar/Grid.jsx';
import PageWrapper from '@components/UI/PageWrapper/Index.jsx';

function ConsultarSolicitacoes() {
  const NomeForm = "Consultar Solicitações";
  const { state, setData, deleteItem } = useGenericReducer();

  const [filters, setFilters] = useState({
    tipoCompliance: "",
    numeroSolicitacao: "",
    dataSolicitacaoInicial: "",
    dataSolicitacaoFinal: "",
    nomeUnidadeGerencia: "",
    nomeAuditor: "",
    nomeProcesso: "",
    statusSolicitacao: null,
  });

  return (
    <PageWrapper>
      <BreadcrumbComp Param1="Home" Param2="Solicitações e Pendências" Param3={NomeForm} />
      <div className="row">
        <div className="col-12 col-md-12">
          <div className="block h-auto">
            <div className="container-fluid">
              <div className="row">

                <div className="col-12 col-md-6 d-flex align-items-center">
                  <i className="fa-solid fa-filter filter-icon"></i>
                  <h2 className="mb-0 p-2">Filtros</h2>
                </div>

                <div className="col-12 col-md-6 d-flex align-items-center justify-content-end">
                  <button className="btn btn-menu">
                    <i className="fa-solid fa-bars"></i>
                  </button>
                </div>

                <FilterAdmin
                  setFilters={setFilters}
                />

                <GridConsultasSolicitacoes
                  state={state}
                  setData={setData}
                  filters={filters}
                  onDelete={deleteItem}
                />

              </div>
            </div>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};

export default ConsultarSolicitacoes;
